export function documentsToggle() {

    let documentsContainer = $(".parameters");

    if (documentsContainer.length) {
        let items = documentsContainer.find(".parameters-item");
        let itemsContainer = documentsContainer.find(".parameters-list");
        let containerHeight = 0;
        let documentButton = $(".document-button");

        for (let i = 0; i <= 7; i++) {

            containerHeight += items.eq(i).outerHeight();
        }

        if (items.length < 9) {
            documentsContainer.addClass("hide-button");
        }

        itemsContainer.css("max-height", containerHeight + "px");

        documentButton.on("click", function () {
            documentsContainer.toggleClass("show-all");
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/documentsToggleList.js